import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const LogoIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 493.33 105.48">
    <g>
      <path
        fill="currentColor"
        className="logo-1"
        d="M169.68,30.25c-.41,4.76-1.53,5.94-5.17,5.94h-7.38v-13.67h3.95c3.17,0,4.05.87,4.25,3.64h2.76v-10.29h-2.76c-.2,2.92-1.13,3.64-4.3,3.64h-3.89V6.9h6.91c3.32,0,3.99,1.18,5.12,5.07h3.07l-.56-8.2h-24.93v2.15c3.07.05,3.79.87,3.79,3.79v23.65c0,2.92-.71,3.69-3.79,3.74v2.1h26.11v-8.96h-3.17Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M201.63,33.57v-13.26c0-4.91-3.02-7.37-7.17-7.37s-6.6,2.05-8.86,4.5c-.1-1.94-.87-3.89-1.18-4.55h-.77l-7.53,2.05v1.94c2.77.11,3.43.61,3.43,4.36v12.33c0,2.92-.61,3.43-3.38,3.58v2.05h12.96v-2.05c-2.92-.1-3.33-.71-3.33-3.38v-13.77c1.64-1.43,3.38-2.51,6.04-2.51,2.25,0,3.54,1.12,3.54,4.2v12.08c0,2.66-.41,3.28-3.33,3.38v2.05h12.75v-2.05c-2.61-.15-3.17-.66-3.17-3.58Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M222.21,36.03c-1.13.36-2,.56-2.92.56-2.56,0-3.07-1.23-3.07-5.07v-14.54h5.37l.77-3.43h-6.14c0-2.61.2-5.74.46-7.58l-3.99.61c-1.23,1.95-2,4.56-2.35,6.91l-3.43,1.28v2.2h3.07v15.77c0,5.38,2.45,7.17,6.76,7.17,2.3,0,4.25-.57,6.09-1.64l-.61-2.25Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M241.3,12.84c-2.76,0-5.53,2.31-7.17,6.3-.05-3.12-.87-5.48-1.23-6.25h-.77l-7.53,2.05v1.94c2.77.11,3.43.61,3.43,4.36v12.33c0,2.92-.61,3.43-3.38,3.58v2.05h13.82v-2.05c-3.68-.1-4.2-.66-4.2-3.58v-8.39c0-4.46,1.18-5.89,5.22-5.89,1.02,0,1.59.11,2.25.36l1.28-6.55c-.41-.15-1.08-.26-1.75-.26Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M260.71,13.56v2.1c2.56.11,3.33.46,3.23,1.64-.05.31-.16.67-.31,1.13l-3.53,11.31c-.72,2.25-1.18,4.2-1.28,4.81h-.2c-.15-.87-.51-2.97-1.38-5.47l-3.58-10.65c-.2-.52-.36-.98-.36-1.28,0-.97.77-1.38,3.17-1.49v-2.1h-12.75v2.1c1.94.26,2.61.87,3.54,3.43l3.99,10.96c1.48,4.09,2.2,6.5,2.87,9.16l2.45-.26c-1.69,4.71-4.91,5.84-9.16,6.71l2,4.3c5.58-.97,8.4-4.36,10.6-10.44l7.32-20.53c.92-2.61,1.59-3.07,3.64-3.33v-2.1h-10.24Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M306.37,29.89c-.97,4.81-2.46,6.29-5.99,6.29h-5.94V9.77c0-2.92.77-3.79,3.95-3.84v-2.15h-14.34v2.15c3.07.05,3.79.87,3.79,3.79v23.65c0,2.92-.71,3.69-3.79,3.74v2.1h24.73l.77-9.31h-3.17Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M334.93,25.28c0-7.83-3.53-12.44-10.85-12.44-6.86,0-11.73,4.92-11.73,13.42s4.5,13.56,12.18,13.56c4.1,0,7.32-1.49,9.94-3.84l-1.13-1.94c-2.04,1.18-4.65,1.94-6.81,1.94-5.12,0-7.37-2.35-7.52-8.9h15.92v-1.8ZM319.06,24.05c.36-6.41,2-8.35,5.02-8.35,3.22,0,4.5,2.15,4.5,8.35h-9.53Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M353.47,13.56v2.1c2.31.05,3.17.52,3.17,1.64,0,.36-.1.82-.3,1.38l-3.64,10.7c-.56,1.64-1.02,3.64-1.13,4.2h-.25c-.16-1.12-.61-2.92-1.08-4.2l-3.79-10.7c-.2-.61-.31-1.02-.31-1.43,0-1.02.77-1.53,3.07-1.59v-2.1h-12.74v2.1c1.89.26,2.51.77,3.48,3.33l7.83,20.48h4.81l7.48-20.48c.93-2.61,1.59-3.07,3.64-3.33v-2.1h-10.24Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M387.05,25.28c0-7.83-3.54-12.44-10.85-12.44-6.86,0-11.73,4.92-11.73,13.42s4.51,13.56,12.18,13.56c4.1,0,7.32-1.49,9.94-3.84l-1.12-1.94c-2.05,1.18-4.66,1.94-6.82,1.94-5.12,0-7.37-2.35-7.52-8.9h15.92v-1.8ZM371.18,24.05c.36-6.41,2-8.35,5.02-8.35,3.23,0,4.5,2.15,4.5,8.35h-9.52Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M399.59,33.47V6.8c0-2.61-.46-4.3-.77-5.06h-.77l-8.4,1.43v1.95c2.87.1,3.69.61,3.69,4.35v24.11c0,2.92-.61,3.43-3.48,3.58v2.05h13.21v-2.05c-2.97-.1-3.48-.71-3.48-3.68Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M160.77,58.39h-14.03v2.15c3.07.05,3.79.87,3.79,3.79v23.65c0,2.92-.71,3.69-3.79,3.74v2.1h13.93c12.03,0,17.15-6.76,17.15-17.61,0-12.6-6.6-17.82-17.05-17.82ZM160.57,90.75h-3.33v-29.28h3.48c6.71,0,9.99,3.43,9.99,15.2s-3.17,14.08-10.14,14.08Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M198,67.45c-2.77,0-5.53,2.31-7.17,6.3-.05-3.12-.87-5.48-1.23-6.25h-.77l-7.52,2.05v1.94c2.76.11,3.43.61,3.43,4.36v12.33c0,2.92-.61,3.43-3.38,3.58v2.05h13.82v-2.05c-3.69-.1-4.2-.66-4.2-3.58v-8.39c0-4.46,1.18-5.89,5.22-5.89,1.02,0,1.59.11,2.25.36l1.28-6.55c-.41-.15-1.08-.26-1.74-.26Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M210.94,88.19v-20.53h-.97l-8.71,1.9v1.94c2.76.11,3.43.61,3.43,4.36v12.33c0,2.92-.61,3.43-3.38,3.58v2.05h12.95v-2.05c-2.92-.1-3.32-.66-3.32-3.58ZM207.51,56.8c-2.2,0-3.94,1.75-3.94,3.89s1.74,3.89,3.89,3.89,3.95-1.75,3.95-3.89-1.69-3.89-3.89-3.89Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M230.81,68.17v2.1c2.3.05,3.17.52,3.17,1.64,0,.36-.1.82-.3,1.38l-3.64,10.7c-.56,1.64-1.02,3.64-1.13,4.2h-.25c-.16-1.12-.61-2.92-1.08-4.2l-3.79-10.7c-.2-.61-.31-1.02-.31-1.43,0-1.02.77-1.53,3.07-1.59v-2.1h-12.75v2.1c1.9.26,2.51.77,3.48,3.33l7.83,20.48h4.81l7.48-20.48c.93-2.61,1.59-3.07,3.64-3.33v-2.1h-10.24Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M264.39,79.89c0-7.83-3.54-12.44-10.85-12.44-6.86,0-11.73,4.92-11.73,13.42s4.51,13.56,12.18,13.56c4.1,0,7.32-1.49,9.94-3.84l-1.12-1.94c-2.05,1.18-4.66,1.94-6.82,1.94-5.12,0-7.37-2.35-7.52-8.9h15.92v-1.8ZM248.52,78.67c.36-6.41,2-8.35,5.02-8.35,3.23,0,4.5,2.15,4.5,8.35h-9.52Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M284,67.45c-2.76,0-5.53,2.31-7.17,6.3-.05-3.12-.87-5.48-1.22-6.25h-.77l-7.52,2.05v1.94c2.76.11,3.43.61,3.43,4.36v12.33c0,2.92-.61,3.43-3.38,3.58v2.05h13.82v-2.05c-3.69-.1-4.2-.66-4.2-3.58v-8.39c0-4.46,1.18-5.89,5.22-5.89,1.02,0,1.59.11,2.25.36l1.28-6.55c-.41-.15-1.08-.26-1.74-.26Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M325.88,58.39h-26.98l-.51,8.81h3.17c.97-4.36,1.33-5.68,4.51-5.68h3.02v26.47c0,3.07-1.08,3.69-4.3,3.74v2.1h15.16v-2.1c-3.23-.05-4.3-.67-4.3-3.74v-26.47h3.02c3.17,0,3.58,1.33,4.5,5.68h3.18l-.46-8.81Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M343.49,67.45c-2.76,0-5.53,2.31-7.17,6.3-.05-3.12-.87-5.48-1.23-6.25h-.77l-7.53,2.05v1.94c2.76.11,3.43.61,3.43,4.36v12.33c0,2.92-.61,3.43-3.38,3.58v2.05h13.82v-2.05c-3.69-.1-4.2-.66-4.2-3.58v-8.39c0-4.46,1.18-5.89,5.22-5.89,1.02,0,1.59.11,2.25.36l1.28-6.55c-.41-.15-1.07-.26-1.74-.26Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M368.67,86.6c0-4.66.2-9.01.2-10.55,0-5.99-3.68-8.6-9.52-8.6-3.84,0-7.89,1.38-10.35,2.77v4.91h4.51c.41-2.56,1.38-4.66,4.96-4.66,3.13,0,4.1,1.84,4.1,5.99v2.31c-.67-.05-1.54-.05-2.15-.05-8.04,0-12.95,2.31-12.95,8.39,0,5.02,3.48,7.43,8.19,7.43,3.95,0,6.19-2.31,7.07-4,.36,2.15,1.59,3.59,4.96,3.59,1.84,0,3.54-.41,4.46-.93v-2c-2.97-.15-3.48-.77-3.48-4.61ZM362.33,87.88c-1.02,1.59-2.82,2.76-4.66,2.76-2.41,0-3.68-.97-3.68-4.25,0-3.48,2.15-5.02,6.7-5.02.41,0,1.38.05,1.79.05l-.15,6.45Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M383.93,88.19v-20.53h-.97l-8.71,1.9v1.94c2.77.11,3.43.61,3.43,4.36v12.33c0,2.92-.61,3.43-3.38,3.58v2.05h12.96v-2.05c-2.92-.1-3.33-.66-3.33-3.58ZM380.5,56.8c-2.2,0-3.94,1.75-3.94,3.89s1.74,3.89,3.89,3.89,3.94-1.75,3.94-3.89-1.69-3.89-3.89-3.89Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M415.21,88.19v-13.26c0-4.91-3.02-7.37-7.17-7.37s-6.6,2.05-8.86,4.5c-.1-1.94-.87-3.89-1.18-4.55h-.77l-7.53,2.05v1.94c2.76.11,3.43.61,3.43,4.36v12.33c0,2.92-.61,3.43-3.38,3.58v2.05h12.95v-2.05c-2.92-.1-3.32-.71-3.32-3.38v-13.77c1.64-1.43,3.38-2.51,6.04-2.51,2.25,0,3.53,1.13,3.53,4.2v12.08c0,2.66-.41,3.28-3.33,3.38v2.05h12.75v-2.05c-2.61-.15-3.18-.66-3.18-3.58Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M430.41,88.19v-20.53h-.97l-8.71,1.9v1.94c2.77.11,3.43.61,3.43,4.36v12.33c0,2.92-.61,3.43-3.38,3.58v2.05h12.96v-2.05c-2.92-.1-3.33-.66-3.33-3.58ZM426.98,56.8c-2.2,0-3.94,1.75-3.94,3.89s1.74,3.89,3.89,3.89,3.94-1.75,3.94-3.89-1.69-3.89-3.89-3.89Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M461.69,88.19v-13.26c0-4.91-3.02-7.37-7.17-7.37s-6.6,2.05-8.86,4.5c-.1-1.94-.87-3.89-1.18-4.55h-.77l-7.53,2.05v1.94c2.76.11,3.43.61,3.43,4.36v12.33c0,2.92-.61,3.43-3.38,3.58v2.05h12.96v-2.05c-2.92-.1-3.33-.71-3.33-3.38v-13.77c1.64-1.43,3.38-2.51,6.04-2.51,2.25,0,3.53,1.13,3.53,4.2v12.08c0,2.66-.4,3.28-3.32,3.38v2.05h12.75v-2.05c-2.61-.15-3.18-.66-3.18-3.58Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M481.25,87.68l-4.81-.16c-1.23-.05-1.64-.51-1.64-1.22,0-.93.97-1.75,2.41-2.2h.41c5.17,0,11.01-1.8,11.01-7.79,0-2.25-1.18-3.89-2.66-4.96,1.28.56,2.36.82,3.48.82,1.43,0,2.66-.46,3.89-1.23l-2.2-4.14c-1.43,1.12-3.07,2.04-4.71,2.04-1.18,0-2.1-.25-3.38-.61-1.54-.42-2.87-.72-4.71-.72-6.29,0-10.34,3.23-10.34,8.5,0,3.69,2.41,6.55,6.4,7.42-3.13.87-5.22,2.66-5.22,4.91,0,2.1,1.07,3.95,3.58,4.25,1.02.16,3.32.31,5.33.36,5.83.21,7.26.87,7.26,3.64s-1.69,4.36-6.55,4.36c-4.3,0-5.78-1.28-5.78-3.95,0-1.02.25-1.89.61-2.56l-3.79.11c-1.28.61-2.62,1.79-2.62,3.58,0,3.32,4.36,5.63,11.52,5.63s12.24-2.92,12.24-8.76c0-5.47-3.43-7.17-9.72-7.32ZM474.28,75.85c0-3.95,1.39-5.53,3.99-5.53,2.77,0,4.05,1.59,4.05,5.68,0,3.73-1.33,5.37-3.99,5.37s-4.05-1.69-4.05-5.53Z"
      />
    </g>
    <g>
      <path
        fill="currentColor"
        className="logo-1"
        d="M0,0v17.82h66.5c-6.34,2.71-12.07,6.66-16.87,11.59H0v17.54h38.38c-.34.88-.66,1.77-.96,2.67-1.07,3.26-2.62,6.26-4.55,8.92H0v17.53h6.72c7.82,0,15.18-2.47,21.22-6.78,3.99-2.84,7.4-6.49,9.99-10.76,1.43-2.36,2.61-4.9,3.5-7.6.45-1.36.95-2.69,1.51-3.99,2.95-6.88,7.39-12.84,12.86-17.54,8.51-7.31,19.54-11.59,31.36-11.59h36.11V0H0Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M55.95,46.94h67.33v-17.54h-36.11c-12.98,0-24.7,6.8-31.22,17.54Z"
      />
      <path
        fill="currentColor"
        className="logo-1"
        d="M38.09,76.07h85.19v-17.53H50.94c-2.95,6.88-7.38,12.84-12.86,17.53Z"
      />
      <rect
        fill="currentColor"
        className="logo-1"
        y="87.66"
        width="123.28"
        height="17.82"
      />
    </g>
  </SvgIcon>
);

export default LogoIcon;
